<template lang="pug">
v-touch.user-info(@tap="viewUser()")
  avatar(:user="user" :size="40")
  .username {{ user.fullname || "Someone" }}
  .clearfix
</template>

<script>
// Components
import Avatar from "@/components/Avatar";

export default {
  name: "UserInfo",
  components: { Avatar },
  props: {
    user: {
      type: [String, Object],
      required: true
    }
  },
  data() {
    return {
      cdnURL: process.env.VUE_APP_CDN_URL
    };
  },
  methods: {
    parseInfo: function(value) {
      return value.replace(/\\/g, "");
    },
    viewUser() {
      this.$router.push({ name: "user", params: { id: this.user._id } });
    }
  }
};
</script>

<style lang="stylus" scoped>
.user-info {
  text-align: left;
  padding: 10px 10px;

  &:hover {
    cursor: pointer;
  }

  .avatar {
    float: left;
    margin-right: 15px;
  }

  .username {
    float: left;
    font-weight: bold;
    line-height: 40px;
  }
}
</style>
